export default __webpack_public_path__ + "static/media/pigeon.1a4e872a.png";